module.exports = __webpack_public_path__ + "static/media/3-1.fd6cbdb2.png";